import React from 'react';
import { hot } from 'react-hot-loader';
import LazyImage from '../../../hocs/Lazy/LazyImage';
import { imageSizeTranslation } from '../../../utils/image';
import s from './Radio.scss';

const Radio = ({ id, options, selected, inputChange, plp = false, hidden = false, variation = false, notifyMe = false }) => {
	const classes = [s.radio];
	if (plp) classes.push(s.radio__plp);
	if (hidden) classes.push(s.radio__hidden);
	if (variation) classes.push(s[`radio__${variation}`]);

	const inputChangeHandler = (e) => {
		e.preventDefault();
		const value = e.target.value;
		const isSoldOut = options.filter((o) => o.key === value && o.disabled);
		inputChange(value, isSoldOut.length > 0 ? value : false);
	};

	return (
		options.map((option) => (
			<label key={option.key} htmlFor={option.key} className={[...classes, (option.key === selected ? s.radio__selected : null), (!notifyMe && option.disabled ? s.radio__disabled : null), (notifyMe && option.disabled ? s.radio__notifyMe : null)].join(' ')}>
				<input className={s.radio_input} id={option.key} type="radio" name={id} value={option.key} checked={option.key === selected} onChange={inputChangeHandler} />
				<span />
				<span className={s.radio_content}>
					<span>{ option.value }</span>
					{ option.stock && <span>({ option.stock })</span> }
				</span>
				{
					option.icons && (
						<span className={s.radio_icons}>{ option.icons.map((icon) => <LazyImage key={icon.icon.url} {...imageSizeTranslation('noResize', icon.icon)} height="28" />) }</span>
					)
				}
				{ option.info && <p className={s.radio_info}>{option.info}</p> }
			</label>
		))
	);
};

export default hot(module)(Radio);
